import { mergeMap, debounceTime } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { UserTranslator } from '@cbridge-packages/user';
import { UserListAction } from '../userList.action';

type IDependencies = IClientApiDependencySegment;

export const loadClientUserListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(UserListAction.loadClient),
  debounceTime(100),
  mergeMap((payload) => {
    return dependencies.api.getUserList(payload).pipe(
      mergeMap((response) => {
        const list = (response.users ?? []).map(UserTranslator.fromApi);

        return [
          UserListAction.loadDone({ list }),
        ];
      }),
      catchApiError((error) => {
        return [
          UserListAction.loadFailed(),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
